"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLineItemNegotiation = void 0;
const module_shopping_list_b2ag_interfaces_1 = require("@invivodf/module-shopping-list-b2ag-interfaces");
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const buildPath = (shoppingListId, lineItems) => `/v1/bff/appro/shopping-lists/${shoppingListId}/line-items/${lineItems}/remove-negotiation`;
const removeLineItemNegotiation = (client) => async ({ shoppingListId, lineItemId }) => {
    try {
        const response = await client.put(buildPath(shoppingListId, lineItemId));
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            switch (error.body.code) {
                case module_shopping_list_b2ag_interfaces_1.ShoppingListNotFoundErrorCode.SHOPPING_LIST_NOT_FOUND:
                case module_shopping_list_b2ag_interfaces_1.UserNotAuthorizedErrorCode.USER_NOT_AUTHORIZED:
                case module_shopping_list_b2ag_interfaces_1.UserServiceApiErrorCode.USER_SERVICE_API_ERROR:
                case module_shopping_list_b2ag_interfaces_1.ShoppingListLineItemNotFoundErrorCode.SHOPPING_LIST_LINE_ITEM_NOT_FOUND:
                    return utils_1.Result.failure({ code: error.body.code, message: error.body.message });
                default:
                    throw error;
            }
        }
        throw error;
    }
};
exports.removeLineItemNegotiation = removeLineItemNegotiation;
